import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { FilterComponent } from '@app/shared/components/filter/filter.component';
import { Filter } from '@app/shared/models/filter';
import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
import {
  DirectService,
  PayoutHistoryChildStatus,
  PayoutHistoryParent,
  PayoutHistoryStatus,
} from '../../services/direct.service';

@Component({
  standalone: false,
  templateUrl: './direct-payout-history.component.html',
  styleUrls: ['./direct-payout-history.component.scss'],
})
export class DirectPayoutHistoryComponent implements OnInit {
  constructor(
    private direct: DirectService,
    private breakpointObserver: BreakpointObserver
  ) { }

  @ViewChild(MatAccordion) accordion: MatAccordion;

  PayoutHistoryStatus = PayoutHistoryStatus;

  isMobile$ = this.breakpointObserver.observe(['(max-width: 1024px)']).pipe(map((res) => res.matches));

  loading: boolean = true;
  payoutHistory: PayoutHistoryParent[] = [];
  stats$ = this.direct.fetchPayoutHistoryStats();

  expandAction: boolean = true;

  // Filters, pagination, search
  filtersUrl = environment.bookingApiUrl + '/filters/payout-history';
  @ViewChild('filterComponent', { static: false }) filterComponent: FilterComponent;

  currentPage: number = 1;
  totalPages: number;

  searchQuery: string = '';
  currentFilters: Filter[] = [];

  ngOnInit(): void {
    this.fetchPayoutHistory();
  }

  fetchPayoutHistory() {
    this.loading = true;
    this.direct.fetchPayoutHistory(this.currentPage, this.searchQuery, this.currentFilters).subscribe((res) => {
      this.payoutHistory = res.data.map((parent) => ({
        ...parent,
        events: parent.events.filter((child) => child.payout_status !== PayoutHistoryChildStatus.SCHEDULED),
      }));
      this.totalPages = res.meta.last_page;
      this.loading = false;
    });
  }

  handlePageChanged(newPageNum: number) {
    this.currentPage = newPageNum;
    this.fetchPayoutHistory();
  }

  handleSearchUpdated(query: string) {
    this.currentPage = 1;
    this.searchQuery = query;
    this.fetchPayoutHistory();
  }

  handleFilterChanged(newFilters: Filter[]) {
    this.currentPage = 1;
    this.currentFilters = newFilters;
    this.fetchPayoutHistory();
  }

  handleFilterReset() {
    this.currentFilters = [];
    this.filterComponent.selfReset();
    this.fetchPayoutHistory();
  }
}
